import $ from 'jquery';

export const fetchQualifyingAutoshipCycles = (params) =>
  $.ajax({
    method: 'GET',
    url: '/horses/pcc_qualifying_autoship_cycles',
    data: params,
  });

export const fetchHorses = (params) =>
  $.ajax({
    method: 'GET',
    url: '/horses',
    data: params,
    beforeSend(xhr) {
      xhr.setRequestHeader(
        'X-CSRF-Token',
        $('meta[name="csrf-token"]').attr('content')
      );
    },
  });

export const fetchHorse = (params) =>
  $.ajax({
    method: 'GET',
    url: `/horses/${params.horseId}`,
    data: params,
  });

export const createHorse = (params) =>
  $.ajax({
    method: 'POST',
    url: '/horses',
    data: params,
    beforeSend(xhr) {
      xhr.setRequestHeader(
        'X-CSRF-Token',
        $('meta[name="csrf-token"]').attr('content')
      );
    },
  });

export const updateHorse = (params) =>
  $.ajax({
    method: 'PATCH',
    url: `/horses/${params.horseId}`,
    data: params,
    beforeSend(xhr) {
      xhr.setRequestHeader(
        'X-CSRF-Token',
        $('meta[name="csrf-token"]').attr('content')
      );
    },
  });

export const fetchHorseAttributes = (params) =>
  $.ajax({
    method: 'GET',
    url: '/horse_attributes',
    data: params,
  });

export const fetchHorseOwner = (params) =>
  $.ajax({
    method: 'POST',
    url: `/horses/${params.horseId}/owner`,
    data: params,
    beforeSend(xhr) {
      xhr.setRequestHeader(
        'X-CSRF-Token',
        $('meta[name="csrf-token"]').attr('content')
      );
    },
  });
